import { useMutation } from "@apollo/client/react";
import { Box, PrimaryButton, Text } from "@nulogy/components";
import ModalFooter from "components/common/ModalFooter";
import Form from "components/controls/Form";
import { PublishWorkBlock } from "hooks/apollo/publishWorkBlock.gql";
import usePublishSummaryModal from "hooks/state/usePublishSummaryModal";
import usePublishWorkBlockModal from "hooks/state/usePublishWorkBlockModal";
import React, { useState } from "react";
import JobCount from "./JobCount";

const FORM_ID = "publish-work-block-modal";
const DEFAULT_RESPONSE_STATE = { errors: [], success: null };

function formErrors(response) {
  const configurationErrors = response.errors.filter((error) => error.path.length !== 3);

  return configurationErrors.length ? configurationErrors : null;
}

function jobCreatedOrUpdatedMessage({ isUpdating }) {
  const verb = isUpdating ? "updated" : "created";

  return (
    <Box fontSize="smaller" lineHeight="smallerText" marginBottom="half">
      Jobs to be {verb}: <JobCount>1</JobCount>
    </Box>
  );
}

export default function PublishWorkBlockModalForm({ workBlock }) {
  const isUpdating = workBlock && !!workBlock.jobId;

  const [response, setResponse] = useState(DEFAULT_RESPONSE_STATE);
  const resetResponse = () => setResponse(DEFAULT_RESPONSE_STATE);
  const [publishWorkBlock, { loading: scheduleWorkBlock }] = useMutation(PublishWorkBlock);
  const submitEnabled = !scheduleWorkBlock;
  const { open: openSummaryModal } = usePublishSummaryModal();
  const { close: closePublishModal } = usePublishWorkBlockModal();

  const onSave = () => {
    resetResponse();

    return publishWorkBlock({
      update: (_proxy, { data }) => {
        const publishResponse = data.publishWorkBlock.publishedWorkBlock;
        const configurationErrors = publishResponse.errors.filter((error) => error.path.length !== 3);
        if (configurationErrors.length) {
          setResponse(publishResponse);
        } else {
          closePublishModal();
          openSummaryModal({
            createdIds: [publishResponse.createdId],
            updatedIds: [publishResponse.updatedId],
            workBlocks: [publishResponse.workBlock],
            ...publishResponse,
          });
        }
      },
      variables: { workBlockId: workBlock.id },
    });
  };

  return (
    <Form errors={formErrors(response)} id={FORM_ID} onSave={onSave}>
      <Text mb="x2">
        Publishing a block will create a corresponding job under its work order. If a block was previously published,
        then updates will be reflected in its existing job.
      </Text>
      <ModalFooter alignItems="center" justifyContent="flex-start">
        <Box marginRight="x2">
          <PrimaryButton className="pendo-create-job" disabled={!submitEnabled} form={FORM_ID} type="submit">
            Publish
          </PrimaryButton>
        </Box>
        <Text className="spec-publish-modal-job-count-message" data-testid="job-count-message">
          {jobCreatedOrUpdatedMessage({ isUpdating })}
        </Text>
      </ModalFooter>
    </Form>
  );
}
